import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreateMaintenanceSchedule($companyId: ID!, $attributes: MaintenanceScheduleAttributes!) {
    createMaintenanceSchedule(companyId: $companyId, attributes: $attributes) {
       maintenanceSchedule {
        id
        ...CreatedMaintenanceSchedule
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedMaintenanceSchedule on MaintenanceSchedule {
    id
    maintenanceType {
      id
      name
    }
    details
    repeatMultiplier
    repeatPeriod
  }
`
